const HOLIDAYS = [
  {
    name: "New Year's",
    // Dec 26–Jan 7 (wraps the year boundary)
    ranges: [{ startM: 12, startD: 26, endM: 1, endD: 7 }],
    gradient: 'linear-gradient(135deg, #0F0E17 0%, #1A1A3E 30%, #2C2851 60%, #3D2B1F 100%)',
    primary: '#D4A574',
    secondary: '#C9A961',
    background: '#1A1A3E',
    appbar: '#2C2851',
    link: '#D4A574',
  },
  {
    name: "Valentine's Day",
    ranges: [{ startM: 2, startD: 1, endM: 2, endD: 21 }],
    gradient: 'linear-gradient(135deg, #880E4F 0%, #C2185B 35%, #E91E63 60%, #AD1457 100%)',
    primary: '#C2185B',
    secondary: '#F48FB1',
    background: '#FCE4EC',
    appbar: '#880E4F',
    link: '#880E4F',
  },
  {
    name: "St. Patrick's Day",
    ranges: [{ startM: 3, startD: 1, endM: 3, endD: 20 }],
    gradient: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 35%, #388E3C 65%, #1B5E20 100%)',
    primary: '#2E7D32',
    secondary: '#F9A825',
    background: '#E8F5E9',
    appbar: '#1B5E20',
    link: '#2E7D32',
  },
  {
    name: 'Easter',
    // Approximate fixed window — Easter varies but falls Mar 22–Apr 25
    ranges: [{ startM: 3, startD: 21, endM: 4, endD: 20 }],
    gradient: 'linear-gradient(135deg, #F8BBD0 0%, #E1BEE7 25%, #B3E5FC 50%, #C8E6C9 75%, #FFF9C4 100%)',
    primary: '#AB47BC',
    secondary: '#66BB6A',
    background: '#F3E5F5',
    appbar: '#7B1FA2',
    link: '#7B1FA2',
  },
  {
    name: "Mother's Day",
    // Second Sunday of May — approximate fixed window Apr 21–May 12
    ranges: [{ startM: 4, startD: 21, endM: 5, endD: 12 }],
    gradient: 'linear-gradient(135deg, #FCE4EC 0%, #F8BBD0 30%, #E1BEE7 65%, #FCE4EC 100%)',
    primary: '#E91E63',
    secondary: '#CE93D8',
    background: '#FCE4EC',
    appbar: '#AD1457',
    link: '#C2185B',
  },
  {
    name: 'Memorial Day',
    // Last Monday of May — approximate May 20–31
    ranges: [{ startM: 5, startD: 20, endM: 5, endD: 31 }],
    gradient: 'linear-gradient(135deg, #0D47A1 0%, #1565C0 30%, #B71C1C 60%, #1565C0 100%)',
    primary: '#1565C0',
    secondary: '#B71C1C',
    background: '#E3F2FD',
    appbar: '#0D47A1',
    link: '#1565C0',
  },
  {
    name: 'Independence Day',
    ranges: [{ startM: 6, startD: 20, endM: 7, endD: 10 }],
    gradient: 'linear-gradient(135deg, #0D47A1 0%, #1A237E 25%, #B71C1C 55%, #C62828 75%, #0D47A1 100%)',
    primary: '#C62828',
    secondary: '#0D47A1',
    background: '#E3F2FD',
    appbar: '#0D47A1',
    link: '#C62828',
  },
  {
    name: 'Halloween',
    ranges: [{ startM: 10, startD: 1, endM: 10, endD: 31 }],
    gradient: 'linear-gradient(135deg, #212121 0%, #4A148C 30%, #6A1B9A 55%, #E65100 80%, #212121 100%)',
    primary: '#E65100',
    secondary: '#7B1FA2',
    background: '#1A0030',
    appbar: '#4A148C',
    link: '#FF6D00',
  },
  {
    name: "Veterans Day",
    ranges: [{ startM: 11, startD: 5, endM: 11, endD: 13 }],
    gradient: 'linear-gradient(135deg, #0D47A1 0%, #1A237E 40%, #B71C1C 70%, #880E24 100%)',
    primary: '#1565C0',
    secondary: '#B71C1C',
    background: '#E3F2FD',
    appbar: '#0D47A1',
    link: '#1565C0',
  },
  {
    name: 'Thanksgiving',
    ranges: [{ startM: 11, startD: 14, endM: 11, endD: 30 }],
    gradient: 'linear-gradient(135deg, #FFECB3 0%, #FFCC80 25%, #FF8F00 50%, #BF360C 75%, #4E342E 100%)',
    primary: '#E65100',
    secondary: '#F9A825',
    background: '#FFF8E1',
    appbar: '#BF360C',
    link: '#E65100',
  },
  {
    name: 'Christmas',
    ranges: [{ startM: 12, startD: 1, endM: 12, endD: 25 }],
    gradient: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 25%, #388E3C 50%, #B71C1C 75%, #1B5E20 100%)',
    primary: '#B71C1C',
    secondary: '#2E7D32',
    background: '#E8F5E9',
    appbar: '#1B5E20',
    link: '#B71C1C',
  },
];

// No holiday match — fall through to env vars / hard-coded defaults in App.js
const DEFAULT_THEME = {
  name: 'default',
  gradient: null,
  primary: null,
  secondary: null,
  background: null,
  appbar: null,
  link: null,
};

function dateInRange(month, day, startM, startD, endM, endD) {
  const currVal = month * 100 + day;
  const startVal = startM * 100 + startD;
  const endVal = endM * 100 + endD;

  if (startVal <= endVal) {
    return currVal >= startVal && currVal <= endVal;
  }
  // Range wraps across the year boundary (e.g. Dec 26 – Jan 7)
  return currVal >= startVal || currVal <= endVal;
}

export function getHolidayTheme(date = new Date()) {
  const month = date.getMonth() + 1; // getMonth() is 0-indexed
  const day = date.getDate();

  for (const holiday of HOLIDAYS) {
    for (const { startM, startD, endM, endD } of holiday.ranges) {
      if (dateInRange(month, day, startM, startD, endM, endD)) {
        return holiday;
      }
    }
  }

  return DEFAULT_THEME;
}
